<template>
  <div class="one-list__purchase-product">
    <div class="product-content one-detail">
      <div class="product-content__img">
        <img :src="orderItem.order_item_picture" alt="" />
      </div>
      <div class="product-content__text">
        <div class="product-content__text-name">
          <span
            class="name"
            title="包月方案 (桃園)包月方案 (桃園)包月方案 (桃園)"
          >
            {{ orderItem.name }}
          </span>
          <!-- prettier-ignore -->
          <span class="business-user" v-if="orderItem.order_item_type == 1">商</span>
        </div>
        <div class="product-content__text-discount">
          {{ orderItem.combination_name }}
        </div>
      </div>
    </div>
    <div class="product-price one-detail">
      <span>$ {{ orderItem.price }}</span>
    </div>
    <div class="product-amount one-detail">x{{ orderItem.count }}</div>

    <div class="one-detail">
      {{ offerName }}
    </div>

    <div class="one-detail">$ {{ orderItem.subtotal }}</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    orderItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    offerName() {
      let type = this.orderItem.discount_type;

      switch (type) {
        case 1:
          return '贈品';
        case 2:
          return '折扣' + this.orderItem.discount_number + '%';
        case 3:
          return '折價' + this.orderItem.discount_number + '元';
        case 5:
          return this.orderItem.combination_name;
        default:
          return null;
      }
    }
  }
};
</script>
